// import Amplify, * as AmplifyModules from 'aws-amplify';
import { Auth, API } from 'aws-amplify';
import store from '@/store'
import axios from 'axios'
// import { $cookies } from 'vue-cookies';
// import VueGtag from "vue-gtag";



export const authService = {

  getUserSession,
  getCurrentUser,

  awsSignin,
  awsRegisterBasic,
  // awsRegisteredUserData,

  fbGetProfile,

  preSignUser,
  mapUser,
  getMe,

  addUserWallet,

  getCurrentUserCredentials,
  setAuthCookie,
  redirectToApp,

  federatedSign,

  signOut
};

// Most populated object - contains session too
async function getCurrentUser() {

  try {

    const curAuth = await Auth.currentAuthenticatedUser();
    store.currentUser = curAuth;  // always update
    return curAuth;
    // return curAuth != undefined && curAuth.id != "";

  } catch (error) {
    // console.log(error)
    return null;
  }
}

// Gets session Tokens (Access, Id)
async function getUserSession() {

  try {

    const session = await Auth.currentSession();

    // console.log("Auth.currentSession", session)
    if (session) {
      return session;
    }
    else return null;

  } catch (error) {
    // console.log(error)
    return null;
  }
}



async function getCurrentUserCredentials() {

  try {
    var creds = await Auth.currentUserCredentials();
    // console.log("Auth.currentUserCredentials", creds);
    return creds;
  } catch (error) {
    // console.log(error)
    return null;
  }

}


async function awsSignin(email, password) {
  try {
    const user = await Auth.signIn({
      username: email,
      password: password
    });

    return user;

  } catch (err) {
    console.log('error signing in : ', err)
    throw err;
  }
}



async function awsRegisterBasic(username, password, email) {
  try {
    
    const registeredUser = await Auth.signUp({
      username: username,
      password: password,
      attributes: {
        email: email
      }
    })
    // console.log('user successfully registered');
    this.awsRegisteredUserData = registeredUser;

    return registeredUser;

  } catch (err) {
    console.log('error signing up...', err)
    throw err;
  }
}

async function awsConfirmSignupWithCode(email, code) {
  try {
    // const confirmation = await Auth.confirmSignUp(this.awsRegisteredUserData.user.username, code);
    const confirmation = await Auth.confirmSignUp(email, code);
    // console.log(confirmation);
    return true;
  } catch (err) {
    console.log('error resending code: ', err);
    return false
  }
}


async function awsResendVerificationCode() {
  try {
    const confirmation = await Auth.resendSignUp(this.awsRegisteredUserData.user.username);
    // console.log(confirmation);
    return true;
  } catch (err) {
    // console.log('error resending code: ', err);
    return false
  }
}


async function fbGetProfile() {
  // need email before all
  return new Promise((resolve) => {

    FB.api('/me', { locale: 'fr_FR', fields: 'name,email' },
      function (response) {
        // console.log(response.email);
        // console.log(response.name);
        resolve(response);
      }
    );

  });
}



async function preSignUser(provider, email, sponsorshipCode, consoleId, playertag, optin, firstName, lastName, profilePicture) {

  // const apiName = 'awgapi';
  const path = '/public/presignup';
  const content = {
    body: {
      "Email": email,
      "Provider": provider,
      "Sponsorship": sponsorshipCode,
      "Optin": optin,
      "FirstName": firstName,
      "LastName": lastName,
      "ProfilePicture": profilePicture
    }
  };

  const oktoSign = await axios.post(process.env.VUE_APP_API_URL + path, content.body, content.headers)
  return oktoSign;
  
}


async function mapUser(email, provider, sponsorshipCode, optin, firstName, lastName, profilePicture) {
  
  const path = '/signup/map';
  const body = {
    "Email": email,
    "Provider": provider,
    "Sponsorship": sponsorshipCode,
    "Optin": optin,
    "FirstName": firstName,
    "LastName": lastName,
    "ProfilePicture": profilePicture
  }
  
  const config = {
    headers: {
      'Authorization' : (await Auth.currentSession()).getIdToken().getJwtToken()
    }
  }
  // const mappedUser = await API.post(apiName, path, content);
  const mappedUser = await axios.post(process.env.VUE_APP_API_URL + path, body, config)  

  if (mappedUser) return mappedUser;
  else throw new Error()

}

async function addUserWallet(walletAddress) {
  
  const path = '/signup/wallet';
  const body = {
    "Address": walletAddress
  }
  
  // const config = {
  //   headers: {
  //     'Authorization' : (await Auth.currentSession()).getIdToken().getJwtToken()
  //   }
  // }

  const client = axios.create();
  client.interceptors.request.use(async (req) => {
    req.headers.authorization = (await Auth.currentSession()).getIdToken().getJwtToken();
    return req;
  });
  
  client.interceptors.response.use((response) => {
    return response;
  }, function (error) {
      // Do something with response error
      if (error.response.status === 422) {
        console.log('422 ERR !');
      }
      return Promise.reject(error.response);
  });

  return client.post(process.env.VUE_APP_API_URL + path, body)
    .then(response => response.data)

}



async function getMe() {
  
  const path = '/me';
  
  const config = {
    headers: {
      'Authorization' : (await Auth.currentSession()).getIdToken().getJwtToken()
    }
  }
  const mappedUser = await axios.get(process.env.VUE_APP_API_URL + path, config)  

  if (mappedUser) return mappedUser;
  else throw new Error()

}





function setAuthCookie(idToken) {
  $cookies.set("Authorization", btoa(JSON.stringify(idToken)), null, null, process.env.VUE_APP_COOKIE_DOMAIN);
}

function redirectToApp() {

  window.location = process.env.VUE_APP_APP_URL + window.location.search;
  // window.location("app.winerz.com");
}


async function federatedSign(provider) {
  debugger
  if (provider !== '') {

    if (store.currentUser != null) {
      // await signOut()

      // delete all cookies involved
      const cogCookies = $cookies.keys().filter(k => k.indexOf('CognitoIdentityServiceProvider') != -1);
      for (let index = 0; index < cogCookies.length; index++) {
        $cookies.remove(cogCookies[index]);
      }

      const fedRes = await Auth.federatedSignIn({ provider: provider })
      
    }
    else
    Auth.federatedSignIn()
  }
}


async function signOut() {
  try {
    await Auth.signOut();
  } catch (error) {
    // console.log('error signing out: ', error);
  }
}